/**
 * Soundboard playback — pure DOM, no React dependency.
 * Decoupled so the same module can be exercised from tests using a
 * stub `<audio>` factory.
 */

const cache = new Map<string, HTMLAudioElement>();

/**
 * Play a clip resolved by key 'board/clip'. The server's `sound_message`
 * evt provides both `p` (key) and `file` (resolved with extension).
 * If `file` is absent we let the browser try '<key>.mp3'.
 */
export function play(key: string, file?: string, baseUrl = '/prochat/soundboards/'): void {
    if (typeof document === 'undefined') return; // SSR / test guard
    const path = file ? file : `${key}.mp3`;
    let a = cache.get(path);
    if (!a) {
        a = new Audio(baseUrl + path);
        a.preload = 'none';
        cache.set(path, a);
    }
    try {
        a.currentTime = 0;
        void a.play().catch(() => { /* autoplay-blocked is OK */ });
    } catch { /* ignore */ }
}

/** Returns true if the browser supports HTML5 Audio. */
export function audioSupported(): boolean {
    return typeof Audio !== 'undefined';
}
